import { Button } from "@/common/components/button";
import { AccountantAuditWrapper } from "../style";
import Table from "@/common/components/Table";
import {
  accountantAuditTableHeaders,
  accountantAuditTableKeys,
  getAccountantAuditTableData,
} from "../data";

const AccountantAudit = () => {
  return (
    <AccountantAuditWrapper>
      <div className="cta-financials">
        <Button secondary>Export</Button>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={accountantAuditTableHeaders}
          tableKeys={accountantAuditTableKeys}
          tableData={getAccountantAuditTableData()}
          tableTitle="Audit Trail"
          rowLineColor="light"
        />
      </div>
    </AccountantAuditWrapper>
  );
};

export default AccountantAudit;
